export * from './landingContentTypes.js';
export { applicationPortal, resolveApplicationPortalBase } from './landingContentShared.js';

import type { LandingContent, LandingLocale } from './landingContentTypes.js';
import { assets, brandAssetRepository } from './landingContentShared.js';
import { deContent } from './landingContent.de.js';
import { activeTrContent } from './landingContent.tr.js';
import { activeEnContent } from './landingContent.en.js';
import { industryNavigationItems } from './industryPages.js';
import { mobileNavigationContent } from './mobileNavigationContent.js';

class LandingPageContentRepository {
  readonly defaultLocale: LandingLocale = 'de';
  readonly locales: LandingLocale[] = ['de', 'tr', 'en'];
  readonly logo = brandAssetRepository.navbarLogoDataUri;
  readonly heroImage = assets.hero;
  readonly partnerLogo = assets.partner;
  readonly partnerSecondaryLogo = assets.partnerSecondary;
  readonly articleImage = assets.article;

  getContent(locale: LandingLocale): LandingContent {
    const source = locale === 'tr' ? activeTrContent : locale === 'en' ? activeEnContent : deContent;
    return { ...source, industryNav: industryNavigationItems(locale), mobileNavigation: mobileNavigationContent(locale) };
  }

  isLocale(value: string | null | undefined): value is LandingLocale {
    return value === 'de' || value === 'tr' || value === 'en';
  }
}

export const landingPageContentRepository = new LandingPageContentRepository();
